export const engagmentModelPageData = {
  understandEngageModal: {
    heading: "Understanding Engagement Models",
    paragraphOne:
      "Finding the right way to collaborate can make all the difference in a project’s success. Our engagement models are designed to give businesses the flexibility to hire tech talent that matches their exact needs. Whether you need dedicated teams, remote developers, or a contract based hiring approach, we ensure a smooth process that delivers results.",
    paragraphTwo:
      "Selecting the best IT outsourcing strategy is key to project efficiency & long term growth. Our models provide businesses with scalable, reliable, & cost effective hiring solutions, ensuring seamless execution, optimized costs, & high quality outcomes.",
    greenHeading: "Benefits of Bitsclan’s Engagement Models:",
    objectiveList: [
      {
        id: 1,
        description:
          "Flexibility to scale your development team as your business grows.",
      },
      {
        id: 2,
        description:
          "Access to a dedicated team of professionals aligned with your project goals.",
      },
      {
        id: 3,
        description:
          "Optimized processes that streamline workflows & reduce overhead costs.",
      },
      {
        id: 4,
        description:
          "Improved project efficiency, leading to faster delivery & better overall outcomes.",
      },
      {
        id: 5,
        description:
          "Adapted to changing business requirements with engagement models that stay flexible.",
      },
      {
        id: 6,
        description:
          "Predictable development costs while maintaining high quality standards.",
      },
      {
        id: 7,
        description:
          "Long term partnerships that support continuous growth & innovation.",
      },
    ],
  },

  engagementModalScroller: {
    heading: "Choose Flexible Engagement Models to Align Speed & Delivery",
    paragraphOne:
      "Our team works with five major IT engagement models depending on the wants & needs of your project. Each model goes beyond simple hiring, delivering agility, cost-effectiveness, & ownership while enabling confident resource management & long-term business growth.",
    helpModelList: {
      heading: "Our models are designed to help you:",
      list: [
        "Reduce risks with transparent cost structures",
        "Scale quickly with on demand expertise",
        "Achieve predictable outcomes & faster time to market",
        "Focus on growth while we ensure flawless delivery",
      ],
    },
    iNeedThisButton: "Choose Your Model",
    benefits: "Key Advantages:",
    ModelsContent: {
      heading: "Engagement Models That Empower Your Business",
      description: "At <strong>Bitsclan IT Solutions</strong>, we believe every partnership deserves a model that adapts to your unique business needs. Our engagement models are designed to provide the <strong>right balance of flexibility, accountability, & transparency</strong> ensuring your projects succeed without compromise. <br/> <br/> Whether you’re scaling quickly, managing long term growth, or launching a defined project, we offer models that give you the <strong>clarity of process & confidence of delivery</strong>."
    },
    scrollerData: [
      // {
      //   title: "Build Operate Transfer (BOT)",
      //   description:
      //     "The BOT model is designed for SMB seeking to establish a dedicated offshore or nearshore IT vendors without handling the complexities themselves.",
      //   benefits: [
      //     "End to end setup: hiring, infrastructure, & processes managed by us.",
      //     "Seamless transfer of team, IP, & processes when fully established.",
      //     "Risk free expansion into new markets with reduced operational overhead.",
      //   ],
      //   modelTitle: "Best For:",
      //   modelPoints: [
      //     "SMB planning long term.",
      //     "Large scale offshore centers.",
      //   ],
      //   modelTitleTwo: "Refund Policy:",
      //   modelPointsTwo: [
      //     "Non refundable (due to long term infrastructure & operational investment)."
      //   ],
      //   userImage: "engagement-model1.png",
      // },
      {
        title: "Flexible Team",
        description:
          "Bridge <strong>critical skill gaps quickly</strong> with our pre vetted professionals, integrated seamlessly into your existing teams.",
        benefits: [
          "Rapid onboarding & immediate productivity.",
          "Scale resources up or down without long term overhead.",
          "Cost efficient access to specialized expertise.",
        ],
        modelTitle: "Best For:",
        modelPoints: [
          "Companies needing short term skills.",
          "Seasonal spikes.",
          "Fast delivery.",
        ],
        modelTitleTwo: "Refund Policy:",
        modelPointsTwo: [
          "Refund option available during the onboarding/trial period.",
        ],
        userImage: "engagement-model3.png",
      },
      {
        title: "Dedicated Teams",
        description:
          "Our dedicated teams act as a <strong>true extension of your organization</strong>, focused entirely on your success.",
        benefits: [
          "Full time commitment with domain specific expertise.",
          "Transparent communication, reporting, & delivery.",
          "Flexibility to scale as your project evolves.",
        ],
        modelTitle: "Best For:",
        modelPoints: [
          "Ongoing projects.",
          "Startups scaling fast.",
          "SMB needing dedicated support.",
        ],
        modelTitleTwo: "Refund Policy:",
        modelPointsTwo: [
          "Refund option available during the onboarding/trial period.",
        ],
        userImage: "engagement-model2.png",
      },
      {
        title: "End-to-End Delivery",
        description:
          "For projects with a <strong>clearly defined scope & timeline</strong>, this model ensures delivery within a fixed budget.",
        benefits: [
          "Upfront clarity on scope, timeline, & cost.",
          "Predictable outcomes with no hidden surprises.",
          "Hands off execution while you focus on strategy.",
        ],
        modelTitle: "Best For:",
        modelPoints: [
          "Well defined.",
          "Time sensitive projects with strict requirements.",
        ],
        modelTitleTwo: "Refund Policy:",
        modelPointsTwo: [
          "Non refundable (due to fixed scope & resource allocation).",
        ],
        userImage: "engagment-scroll-image4.png",
      },
      // {
      //   title: "White Label Partnership",
      //   description:
      //     "Expand your portfolio by offering our solutions under <strong>your own brand</strong>. Perfect for agencies & consultancies looking to scale.",
      //   benefits: [
      //     "Accelerate time to market with ready to deploy solutions.",
      //     "Confidential partnership you keep full brand ownership.",
      //     "Cost savings by avoiding development from scratch.",
      //   ],
      //   modelTitle: "Best For:",
      //   modelPoints: [
      //     "Agencies.",
      //     "Resellers.",
      //     "SMB scaling their service offerings.",
      //   ],
      //   modelTitleTwo: "Refund Policy:",
      //   modelPointsTwo: [
      //     "Non refundable (due to IP licensing & brand commitments).",
      //   ],
      //   userImage: "engagement-model7.png",
      // },
    ],
  },
};

export const EngagementModelPageBannerDataEn = {
  mainHeading: "Flexible Engagement Models Tailored to Your Business",
  greenHeading: "Our Approach to the Engagement Process.",
  content:
    "At <strong>Bitsclan IT Solutions</strong> we provide flexible engagement models on demand expertise, dedicated teams, or turnkey solutions delivering predictable outcomes, scalable growth, & longterm value.",
  btnText: "Start Your Project",
  bannerList: [
    // { list: "BOT for strategic expansion" },
    // { list: "Dedicated & Augmented Teams for agility" },
    // { list: "Fixed-Price & White-Label solutions for certainty" },
  ],
};
